import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var ServerCrash = createReactComponent("ServerCrash", ["svg", defaultAttributes, [["path", {
  d: "M6 10H4a2 2 0 01-2-2V4a2 2 0 012-2h16a2 2 0 012 2v4a2 2 0 01-2 2h-2",
  key: "16j29y"
}], ["path", {
  d: "M6 14H4a2 2 0 00-2 2v4a2 2 0 002 2h16a2 2 0 002-2v-4a2 2 0 00-2-2h-2",
  key: "1t0co4"
}], ["path", {
  d: "M6 6h.01",
  key: "1wio8d"
}], ["path", {
  d: "M6 18h.01",
  key: "1t0lit"
}], ["path", {
  d: "M13 6l-4 6h6l-4 6",
  key: "160ein"
}]]]);
export default ServerCrash;